import { CustomValidatorFn, ValidationErrorKeys } from '@shared/form-elements/model/form-elements.model';

export const regexValidator = (regex: RegExp, error: ValidationErrorKeys): CustomValidatorFn => control => {
    if (!control.value) {
        return null;
    }

    const valid = regex.test(control.value);

    return valid ? null : { [error]: true };
};
